import type { DealerCategoryAndFabricGradeRestrictions } from "../../api/restrictions/types";

/** Resolve imported Accent labels to the grade key used by Threekit and dealer rules. */
export const normalizeFabricGrade = (grade: unknown): string => {
  const value = typeof grade === "string" ? grade.trim() : "";
  return ["accent", "accent/pillow", "accents"].includes(value.toLowerCase()) ? "Accents" : value;
};

export const isFabricGradeAvailable = (
  grade: unknown,
  restrictions: Partial<DealerCategoryAndFabricGradeRestrictions> | null | undefined
): boolean => {
  if (!restrictions) return true;
  const key = normalizeFabricGrade(grade) as keyof DealerCategoryAndFabricGradeRestrictions;
  return restrictions[key] === true;
};
